export default "__VITE_ASSET__Cfz835GH__"